<template>
  <a-modal title="终止筛选" :width="1000" :visible="failVisible" :confirmLoading="loading" @ok="handleFailSubmit"
    @cancel="failVisible = false">
    <a-form-model layout="horizontal" :model="failModel" v-bind="{ labelCol: { span: 4 }, wrapperCol: { span: 16 }, }"
      ref="ruleForm" :rules="rules">

      <a-form-model-item prop="typeList" label="终止原因">
        <a-checkbox-group v-model="failModel.typeList">
          <a-checkbox value="1">不符合纳入标准</a-checkbox>
          <a-checkbox value="2">符合排除标准</a-checkbox>
          <a-checkbox value="3">受试者拒绝参加项目</a-checkbox>
          <a-checkbox value="4">其他原因</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item v-if="failModel.typeList.indexOf('1') >= 0" prop="type1Info" label="不符合纳入标准">
        <a-checkbox-group v-model="failModel.type1Info" @change="onType1Change">
          <a-row>
            <a-col :span="24" v-for="(item, index) in dataSource1" :key="index" style="margin-bottom: 5px">
              <a-checkbox :value="item.id">{{ `${item.description}` }}</a-checkbox>
            </a-col>
            <a-textarea :rows="4" v-model="failModel.type1Remark" placeholder="非必填" v-show="failType1Visible" />
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item v-if="failModel.typeList.indexOf('2') >= 0" prop="type2Info" label="符合排除标准">
        <a-checkbox-group v-model="failModel.type2Info" @change="onType2Change">
          <a-row>
            <a-col :span="24" v-for="(item, index) in dataSource2" :key="index" style="margin-bottom: 5px">
              <a-checkbox :value="item.id">{{ `${item.description}` }}</a-checkbox>
            </a-col>
            <a-textarea :rows="4" v-model="failModel.type2Remark" placeholder="非必填" v-show="failType2Visible" />
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item v-if="failModel.typeList.indexOf('4') >= 0" prop="type4Info" label="其他原因">
        <a-textarea :rows="4" v-model="failModel.type4Info" placeholder="非必填" />
      </a-form-model-item>

    </a-form-model>
  </a-modal>
</template>

<script>
import baseRules from '@/constants/baseRules'
import { getAction, postAction } from '@/api/manage'
export default {
  name: 'FailFiltrate',
  props: {
    patient: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      failVisible: false,
      failType1Visible: false,
      failType2Visible:false,
      failInfoList: [],
      failModel: {
        typeList: [],
        type1Info: [],
        type2Info: [],
      },
      dataSource: [],
      rules: {
        typeList: [baseRules.requiredChange],
        type1Info: [baseRules.requiredChange],
        type2Info: [baseRules.requiredChange],
      },
    }
  },
  watch: {
    patient() {
      this.loadData()
    }
  },
  computed: {
    dataSource1() {
      return this.dataSource.filter(item => item.type === '1')
    },
    dataSource2() {
      return this.dataSource.filter(item => item.type === '2')
    },

  },
  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.loading = true
      getAction('/project/projectFiltrate/listByCenter', { projectId: this.patient.projectId }).then(res => {
        if (res.success) {
          this.dataSource = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    view() {
      this.failModel = {
        typeList: [],
        type1Info: [],
        type2Info: [],
        type3Info: '',
        type4Info: '',
        type1Remark:'',
        type2Remark:'',
      }
      this.failVisible = true
    },
    onType1Change() {
      if(this.failModel.type1Info.length<=0){
        this.failType1Visible = false;
      }
      this.failModel.type1Info.forEach(CheckItem => {
        const infoList = this.dataSource.filter(item => item.id === CheckItem);
        if (infoList[0].remarkFlag == '1') {
          this.failType1Visible = true;
        }
      });
    },
    onType2Change() {
      if(this.failModel.type2Info.length<=0){
        this.failType2Visible = false;
      }
      this.failModel.type2Info.forEach(CheckItem => {
        const infoList = this.dataSource.filter(item => item.id === CheckItem);
        if (infoList[0].remarkFlag == '1') {
          this.failType2Visible = true;
        }
      });
    },
    handleFailSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const infoList = []
          this.failModel.typeList.forEach(item => {
            const info = { type: item, patientId: this.patient.id }
            if (item === '1') {
              if (this.failModel.type1Info.length > 0) {
                info.info = this.failModel.type1Info.join(',')
                info.remark=this.failModel.type1Remark;
              }
            }
            else if (item === '2') {
              if (this.failModel.type2Info.length > 0) {
                info.info = this.failModel.type2Info.join(',')
                info.remark=this.failModel.type2Remark;
              }
            }
            else if (item === '4') {
              info.info = this.failModel.type4Info
            }
            infoList.push(info)
          })
          postAction('/patient/patient/failFiltrate', infoList).then(res => {
            if (res.success) {
              this.failVisible = false
              this.$emit('opHandle')
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped></style>